// extracted by mini-css-extract-plugin
export default {"section":"edit-card_section__QrPKQ","section__button-group":"edit-card_section__button-group__muEhn"};